'use strict';
module.exports = errSerializer;
var _require = require('./err-helpers'), messageWithCauses = _require.messageWithCauses, stackWithCauses = _require.stackWithCauses, isErrorLike = _require.isErrorLike;
var _require1 = require('./err-proto'), pinoErrProto = _require1.pinoErrProto, pinoErrorSymbols = _require1.pinoErrorSymbols;
var seen = pinoErrorSymbols.seen;
var toString = Object.prototype.toString;
function errSerializer(err) {
    if (!isErrorLike(err)) {
        return err;
    }
    err[seen] = undefined // tag to prevent re-looking at this
    ;
    var _err = Object.create(pinoErrProto);
    _err.type = toString.call(err.constructor) === '[object Function]' ? err.constructor.name : err.name;
    _err.message = messageWithCauses(err);
    _err.stack = stackWithCauses(err);
    if (Array.isArray(err.errors)) {
        _err.aggregateErrors = err.errors.map(function(err) {
            return errSerializer(err);
        });
    }
    for(var key in err){
        if (_err[key] === undefined) {
            var val = err[key];
            if (isErrorLike(val)) {
                // We append cause messages and stacks to _err, therefore skipping causes here
                if (key !== 'cause' && !Object.prototype.hasOwnProperty.call(val, seen)) {
                    _err[key] = errSerializer(val);
                }
            } else {
                _err[key] = val;
            }
        }
    }
    delete err[seen] // clean up tag in case err is serialized again later
    ;
    _err.raw = err;
    return _err;
}
